import type { BulkSelectionStatus } from './types';

const checkAreAllPageItemsSelected = (dataIds: string[], selectedItems: string[]): boolean => {
  return dataIds.every((dataId: string) => selectedItems.includes(dataId));
};

const checkAreSomePageItemsSelected = (dataIds: string[], selectedItems: string[]): boolean => {
  return dataIds.some((dataId: string) => selectedItems.includes(dataId));
};

export const getBulkItemSelectionStatus = (dataIds: string[], selectedItems: string[]): BulkSelectionStatus => {
  if (checkAreAllPageItemsSelected(dataIds, selectedItems)) {
    return 'allPageItemsSelected';
  }

  if (checkAreSomePageItemsSelected(dataIds, selectedItems)) {
    return 'somePageItemsSelected';
  }

  return 'noPageItemsSelected';
};
